var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav_box"},[_c('ul',_vm._l((_vm.nav),function(item,index){return _c('li',{key:index,class:item.type == 'title'?'title' : item.active ? 'c li_active' : 'c',on:{"click":function($event){return _vm.handleClick(item)}}},[_vm._v("\n      "+_vm._s(item.chName)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }